<template>
  <container v-if="!free">
    <v-card fill-height :flat="flat" style="height:100%; width:100%;">
      <v-card-title v-if="title" primary class="title" style="height:15%;width:100%;padding-top:5px;padding-bottom:5px;">
        {{ title }}
        <span
            v-if="maximizeCallback"
            @click="maximizeCallback(chartOptions)"
            class="maximize-icon"
        >
            <font-awesome-icon icon="maximize" style="color:rgb(51,82,128);"/>
          </span>
      </v-card-title>
      <v-card-actions ref="chartContainer" fill-height :style="'height:' + (!!title ? 85 : 100) + '%;width:100%;padding-top:0px;padding-bottom:0px;'">
        <highcharts v-if="load" style="height:100% !important;width:100%;" :options="chartOptions"></highcharts>
      </v-card-actions>
    </v-card>
  </container>
  <container v-else style="height:100%; width:100%;">
    <highcharts v-if="load" style="height:100% !important; width:100%;" :options="chartOptions" />
  </container>
</template>

<script>

import {Chart} from 'highcharts-vue'
import More from 'highcharts/highcharts-more'
import Highcharts from 'highcharts'
import Exporting from 'highcharts/modules/exporting'

Exporting(Highcharts)

More(Highcharts)

export default {
  name: "Chart",
  components: {
    highcharts: Chart
  },
  props: {
    active: Boolean,
    free: Boolean,
    title: String,
    flat: Boolean,
    chartOptions: Object,
    maximizeCallback: Function
  },
  data: function () {
    return {
      load: false
    }
  },
  methods: {
    onResize(event) {
      this.load = false;

      setTimeout(() => {
        if (typeof this.chartOptions != 'undefined' && typeof this.$refs['chartContainer'] != 'undefined') {
          this.chartOptions.chart.height = this.$refs['chartContainer'].clientHeight;
        }
        this.load = true;
      });
    }
  },
  created() {
    window.addEventListener('resize', this.onResize, {passive: true});
  },
  mounted() {
    setTimeout(() => {
      if (typeof this.chartOptions != 'undefined' && typeof this.$refs['chartContainer'] != 'undefined') {
        this.chartOptions.chart.height = this.$refs['chartContainer'].clientHeight;
        this.chartOptions.credits = {enabled: false};
      }
      this.load = true;
    });
  },
  watch: {
    active: function () {
      this.load = false;

      setTimeout(() => {
        if (typeof this.chartOptions != 'undefined' && typeof this.$refs['chartContainer'] != 'undefined') {
          this.chartOptions.chart.height = this.$refs['chartContainer'].clientHeight;
        }
        this.load = true;
      });
    },
    chartOptions: function () {
      this.load = false;

      setTimeout(() => {
        if (typeof this.chartOptions != 'undefined' && typeof this.$refs['chartContainer'] != 'undefined') {
          this.chartOptions.chart.height = this.$refs['chartContainer'].clientHeight;
        }
        this.load = true;
      });
    }
  }
}
</script>

<style>
.maximize-icon {
  position: absolute;
  right: calc(0% + 16px);
}

.maximize-icon:hover {
  cursor: pointer;
}

.maximize-icon svg {
  font-size: 16px;
}
</style>
